import styles from './Meter.module.scss'
import styled from 'styled-components'

import React from 'react'

import classNames from 'classnames'

import ColorFinder from 'Utilities/ColorFinder/ColorFinder'
import LayerColorFinder from 'Utilities/LayerColorFinder/LayerColorFinder'

const Meter = ({ brand, intent, tone, value, min, max, className, height, ...props }) => {
  const { color } = ColorFinder(intent, tone, brand)
  const backgroundColor = LayerColorFinder(3)

  return (
    <StyledMeter
      className={classNames(styles.meter, className)}
      value={value}
      min={min ?? 0}
      max={max}
      color={color}
      backgroundColor={backgroundColor}
      height={height ?? 1.5}
      {...props}
    />
  )
}

const StyledMeter = styled.meter`
  height: ${(props) => props.height}rem;

  @supports (-moz-appearance: none) {
    background: ${(props) => props.backgroundColor};
    height: ${(props) => props.height / 2}rem;
  }

  ::-webkit-meter-bar {
    background: ${(props) => props.backgroundColor};
  }

  /* The green (optimum) bar in Firefox */
  :-moz-meter-optimum::-moz-meter-bar {
    background: ${(props) => props.color};
  }

  /* The green (optimum) bar in Chrome etc. */
  ::-webkit-meter-optimum-value {
    background: ${(props) => props.color};
  }
`

export default Meter
